import React, { useEffect, useState } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { AboutSection, TeamSection, CTABanner } from './AboutTeamSections';
import { AppointmentSection } from './AppointmentSection';
import { Target, Eye } from 'lucide-react';

export const AboutUsPage = () => {
  const [isAppointmentOpen, setIsAppointmentOpen] = useState(false);
  const handleBook = () => setIsAppointmentOpen(true);

  useEffect(() => {
    document.title = 'About Us | Virtual CFO Consultancy — NSRM & Associates';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <meta name="description" content="About Virtual CFO Consultancy — the advisory practice of NSRM & Associates, Chartered Accountants. Offices in Mumbai, Bangalore and UAE." />
      <Header onBookAppointment={handleBook} />

      {/* Page Hero */}
      <section className="pt-32 pb-12 px-4 sm:px-6 bg-gradient-to-br from-slate-50 to-emerald-50">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">About Us</h1>
          <p className="text-gray-600 text-base sm:text-lg">Institutional-grade financial expertise for growing businesses.</p>
        </div>
      </section>

      <AboutSection />

      {/* Mission & Vision */}
      <section className="py-16 px-4 sm:px-6 bg-white">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">
          <div className="bg-emerald-50 rounded-2xl p-6 sm:p-8 border border-emerald-100">
            <Target className="w-8 h-8 text-emerald-600 mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-3">Our Mission</h3>
            <p className="text-gray-700 leading-relaxed text-sm">
              Our mission is to support the success of both our clients and employees by being committed to our beliefs, our professionals, and respecting our diversity.
            </p>
          </div>
          <div className="bg-blue-50 rounded-2xl p-6 sm:p-8 border border-blue-100">
            <Eye className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-3">Our Vision</h3>
            <p className="text-gray-700 leading-relaxed text-sm">
              Being the largest professional services firm is not our goal. Being the most trusted one is.
            </p>
          </div>
        </div>
      </section>

      <TeamSection onBookAppointment={handleBook} />
      <CTABanner onBookAppointment={handleBook} />
      <Footer onBookAppointment={handleBook} />
      <AppointmentSection isOpen={isAppointmentOpen} onClose={() => setIsAppointmentOpen(false)} />
    </div>
  );
};
